import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { FunctionComponent } from 'react';

import { PlanningQuestion } from '../../../../types/work';
import {
    QuestionsHeaderRow,
    SectionCollapseIcon,
    SectionTitle
} from './styled';

interface Props {
    questions: PlanningQuestion[];
    collapsible: boolean;
    expanded: boolean;
    onToggleExpanded: () => void;
}

const QuestionsHeader: FunctionComponent<Props> = ({
    questions,
    collapsible,
    expanded,
    onToggleExpanded
}) => (
    <QuestionsHeaderRow>
        <SectionTitle>
            {collapsible
                ? `${questions.length} question${
                    questions.length !== 1 ? 's' : ''
                } to refine the plan`
                : 'A few questions before we proceed'}
        </SectionTitle>
        {collapsible && (
            <SectionCollapseIcon onClick={onToggleExpanded}>
                {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </SectionCollapseIcon>
        )}
    </QuestionsHeaderRow>
);

export default QuestionsHeader;
